
  <mat-card>


    <mat-card-actions style="justify-content: space-between;">
      <mat-form-field appearance="outline" >
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium" #input>
      </mat-form-field>
      <button  mat-stroked-button mat-button class="button-stepper-back">New Property
        <mat-icon>add</mat-icon>
      </button>
  </mat-card-actions>
 

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  
    <!-- Position Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef> Id. </th>
      <td mat-cell *matCellDef="let element"> {{element.id}} </td>
    </ng-container>
  
    <!-- Name Column -->
    <ng-container matColumnDef="address">
      <th mat-header-cell *matHeaderCellDef> Property Address </th>
      <td mat-cell *matCellDef="let element"> {{element.address}} </td>
    </ng-container>
  
    <!-- Weight Column -->
    <ng-container matColumnDef="owner">
      <th mat-header-cell *matHeaderCellDef> Owner Name </th>
      <td mat-cell *matCellDef="let element"> {{element.owner}} </td>
    </ng-container>
  
    <!-- Symbol Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element"> {{element.status}} </td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  
    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
    </tr>
  </table>
  </mat-card>
